import {useQuery} from '@tanstack/react-query';
import {AxiosError, AxiosResponse} from 'axios';
import axiosInstance from '../../../axiosConfig';
import {IApiDataResponse} from '../../../dto/API.dto';
import {IChildCompany} from '../../../dto/MessageSharing.dto';
import {AxiosErrorToast} from '../../general/ReusableFunctions';

const fetchChildCompanies = (districtCompanyId: number) => {
  return axiosInstance
    .get(`/v1/company/${districtCompanyId}/hierarchy/children`)
    .then((response: AxiosResponse<IApiDataResponse<IChildCompany[]>>) => {
      return response.data.data;
    })
    .catch((error: AxiosError) => {
      AxiosErrorToast(error, 'Error fetching child companies');
      throw error;
    });
};

export const useRqChildCompanies = (
  districtCompanyId: number,
  enabled: boolean = true,
) => {
  return useQuery({
    queryKey: ['api/v1/company', districtCompanyId, 'hierarchy/children'],
    queryFn: () => fetchChildCompanies(districtCompanyId),
    refetchOnWindowFocus: false,
    retry: false,
    staleTime: 5 * 60 * 1000,
    enabled,
  });
};
